import { GridRenderCellParams } from '@mui/x-data-grid';
import styles from './RemoveGroupCell.module.scss';
import { useState } from 'react';
import { RemoveGroupModal } from '../RemoveGroupModal/RemoveGroupModal';
import { RemoveCell } from 'components/common/RemoveCell/RemoveCell';

export interface RemoveGroupCellProps {
    supplierId: string;
    params: GridRenderCellParams;
    onRemoveGroup: (groupName: string) => void;
}

export const RemoveGroupCell = ({
    supplierId,
    params,
    onRemoveGroup,
}: RemoveGroupCellProps) => {
    const [removeGroupDialogOpen, setRemoveGroupDialogOpen] = useState(false);

    const openRemoveGroupDialog = () => {
        setRemoveGroupDialogOpen(true);
    };
    const closeRemoveGroupDialog = () => {
        setRemoveGroupDialogOpen(false);
    };

    return (
        <div className={styles.RemoveGroupCell} data-testid="RemoveGroupCell">
            <RemoveCell onClick={openRemoveGroupDialog} />

            <RemoveGroupModal
                open={removeGroupDialogOpen}
                onClose={closeRemoveGroupDialog}
                groupName={params.row.name}
                supplierId={supplierId}
                onRemoveGroup={onRemoveGroup}
            />
        </div>
    );
};
